import Vue from 'vue'
const getters = {
    loadings: state => state.loadings,
};
export default getters
